import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../primitives/alert-dialog';
import { Countdown } from '../primitives/countdown';

type Props = {
    deadlineAt: number | null;
    onContinue: () => void;
    onSignOut: () => void;
};

export function InactivityWarningDialog({ deadlineAt, onContinue, onSignOut }: Props) {
    return (
        <AlertDialog open={deadlineAt !== null}>
            <AlertDialogContent
                className="sm:max-w-lg"
                onEscapeKeyDown={(event) => event.preventDefault()}
            >
                <AlertDialogHeader>
                    <AlertDialogTitle>Are you still there?</AlertDialogTitle>
                    <AlertDialogDescription className="tracking-wide tabular-nums">
                        Privacy is important, and you've been gone a while. We will log you out in{' '}
                        <b>{deadlineAt !== null && <Countdown deadlineAt={deadlineAt} />}</b> unless
                        you confirm you're still with us.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onSignOut}>Log Out</AlertDialogCancel>
                    <AlertDialogAction onClick={onContinue}>Continue Working</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
